<div class="info-panel-container">
  @if (showContent) {
    <div>
      <h2 title="{{ title }}" class="title">{{ title }}</h2>
      <div class="type">{{ type }}</div>
      <i class="icon fas {{ iconName }}"></i>
      @if (size !== 'unavailable') {
        <div>size: {{ size }}</div>
      }
      @if (backupDate !== null) {
        <div>Backup Date: {{ backupDate * 1000 | date }}</div>
      }
      @if (backupDate !== null) {
        <div>Backup Time: {{ backupDate * 1000 | date:'shortTime' }}</div>
      }
      @if (fileAttrMap) {
        <br>
          <div>Create Date: {{ (fileAttrMap.createDate * 1000 | date: 'short') || 'Unknown' }}</div>
          <div>Access Date: {{ (fileAttrMap.accessDate * 1000 | date: 'short') || 'Unknown' }}</div>
          <div>Modify Date: {{ (fileAttrMap.modifyDate * 1000 | date: 'short') || 'Unknown' }}</div>
          <br>
            <div>Media Label: {{ fileAttrMap.mediaLabel }}</div>
            <div [style.word-break]="'break-all'">Hash: {{ fileAttrMap.hash }}</div>
          }
          @if (sourceExports) {
            <br>
            <div class="source-exports">
              <div>Source exports:</div>
              @for (source of sourceExports; track source.id) {
                <div [style.word-break]="'break-all'">
                  @if (source.hasSourceJson && source.status !== 'queued') {
                    <a [routerLink]="['/dashboard/project', projectId, 'imports', source.id, 'json']">{{ source.fileName }}</a>
                  } @else {
                    {{ source.fileName }}
                  }
                  ({{ statusLabel[source.status] }})
                </div>
              } @empty {
                <div>None on record (imported before import history)</div>
              }
            </div>
          }
        </div>
      }
    </div>
